import _ from "lodash";
import localizedStrings from "../../../public/transifex/translations";
import { t } from "@transifex/native";

// Transifex locales here: https://explore.transifex.com/languages/
export const LOCALE_TO_TRANSIFEX = {
    "fr-FR": "fr_FR",
    "en-US": "en_US",
    "en-GB": "en_GB",
    "de-DE": "de_DE",
    "it-IT": "it_IT",
    "he-Hebr-IL": "he_IL",
    es: "es",
    ja: "ja",
    ko: "ko",
    nl: "nl",
    pt: "pt",
    ru: "ru",
    vi: "vi",
    "zh-Hans": "zh-Hans",
    "zh-Hant": "zh-Hant",
    "zh-Hant-TW": "zh_TW",
};

export const SUPPORTED_LOCALES = ["fr-FR", "en-US"];

export const getTransifexLocaleCode = (locale: string) => {
    return LOCALE_TO_TRANSIFEX[locale];
};

export const isSupportedLocale = (locale: string) => {
    return SUPPORTED_LOCALES.includes(locale);
};

/**
 * Returns a Transifex localized string, and should be used to wrap strings and generate Transifex
 * translation objects.
 * @param key string passed as translation key(ID). Should match the path to translation value in public/transifex/en.json.
 * @param context string used to contextualize string for translaiton team in Transifex.
 *      MUST follow the following format: COMPONENT - COMPONENT_TYPE - DESCRIPTION
 *      See documentation here: https://docs.google.com/document/d/1-qUa7zMpKgIjze6HA3RCFYB__FsWdEcWSpMfa6uEUGM/edit?usp=sharing
 * @returns Returns a Transifex localized string.
 */
export const getLocalized = (key: string, context: string, variables: any = {}) => {
    const translation = _.get(localizedStrings, key.split("."));

    return t(`${translation}`, {
        _context: `${context.trim()}`,
        _tags: `${key.split(".").slice(0, -1).join()}`,
        _key: `${key}`,
        ...variables,
    });
};
